module.exports = "/_next/static/images/333df4623eea7ac55a336b36e47f572b-cajita.png";